<template>
    <div :class="'--done'">
        <div class="uploaded-description">
            <p class="uploaded-description__text">
                Data wysłania:
                <span class="uploaded-description__text-decorator">
                    {{ formatDate(files[0].sentAt, true) }}
                </span>
            </p>
        </div>
        <transition-group name="fade-animation" mode="out-in" class="uploader-files-wrapper">
            <div v-for="file in files" :key="file.id" class="uploader-form-file">
                <div class="uploader-form-file__content">
                    <div class="uploader-form-file__wrapper">
                        <img class="uploader-form-file__icon" alt="" aria-hidden="true"
                            src="@/assets/images/icons/i_homework-file.svg" />
                        <div class="flex flex-col">
                            <span class="uploader-form-file__name">{{ file.fileName }}</span>
                        </div>
                    </div>
                    <span class="uploader-form-file__size">{{ convertKbToMb(file.size) }} MB</span>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HomeworkUploadedList',
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatDate(date, withDots = false) {
      if (withDots) {
        return moment(date).format('DD.MM.YYYY');
      }
      return moment(date).format('DD-MM-YYYY');
    },
    convertKbToMb(sizeInKb) {
      const sizeInMb = sizeInKb / 1024;
      return sizeInMb.toFixed(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.--done {
    background-color: #FAFAFC;
    border: 1px solid #F3F5F8;
    border-radius: 8px;
    padding: 18px;

    @media screen and (min-width: 1280px) {
        padding: 32px;
    }

    .uploader-form-file__status.--txt {
        display: none;
    }

    .uploader-form-file__status.--ctrl {
        padding-left: 54px;
    }
}

.uploaded-description {
    margin-bottom: 24px;

    &__text {
        color: #5B657A;
        font-family: "GT Walsheim Pro";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
    }

    &__text-decorator {
        color: #111724;
    }
}

.uploader-files-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    width: 100%;

    @media screen and (min-width: 1280px) {
        grid-template-columns: 1fr 1fr;
    }
}

.uploader-form-file {
    position: relative;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #E7E9EE;
    background: #FFF;

    @media screen and (min-width: 1280px) {
        max-width: 440px;
    }

    &+.uploader-form-file {
        // @apply mt-3;
    }

    &.inactive {
        display: none;
    }

    @media screen and (min-width: 340px) {
        @apply flex-row items-center;
    }

    &__content {
        @apply flex w-full justify-between text-black leading-tight;
    }

    &__wrapper {
        display: flex;
        gap: 12px;
    }

    &__size {
        overflow: hidden;
        color: #5B657A;
        text-overflow: ellipsis;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        /* 128.571% */
    }

    &__name {
        color: #111724;
        text-overflow: ellipsis;
        font-family: "GT Walsheim Pro";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        max-width: 150px;
        display: block;
        overflow: hidden;
        white-space: nowrap;
    }

    &__icon {
        width: 20px;
        height: 20px;
        align-items: flex-start;
    }

    &__date {
        color: #5B657A;
        font-family: "GT Walsheim Pro";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        margin-top: 12px;
        /* 128.571% */
    }

    &__status {
        position: absolute;
        top: 16px;
        right: 16px;
        @apply flex w-full justify-end items-center font-bold text-green-light text-sm pl-2;

        @media screen and (min-width: 340px) {
            width: auto;
        }

        .failed-status {
            button {
                @apply flex justify-center items-center outline-none;
                cursor: pointer;
                gap: 4px;
                color: #2E384A;
                font-family: "GT Walsheim Pro";
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px;
                white-space: nowrap;
                transition: 0.3s;

                &:hover {
                    color: #E10A7B;
                }
            }
        }
    }
}

.fade-animation-enter-active {
    transition: all 0.4s ease;
}

.fade-animation-leave-active {
    transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-animation-enter,
.fade-animation-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>
